
















































import InputField from '@components/common/input-field.vue';
import { FormAttribute } from '@enums';
import user from '@services/user';
import { VueTranslateResult } from '@types';
import Vue, { PropType } from 'vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
	name: 'UserContactsForm',
	components: { InputField },
	props: {
		buttonText: {
			type: String as PropType<VueTranslateResult>,
			default: '',
		},
		inputClass: {
			type: String,
			default: '',
		},
		contentWrapperClass: {
			type: String,
			default: '',
		},
		buttonClass: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			FormAttribute,
		};
	},
	computed: { ...mapState('common', ['userContacts']) },
	mounted() {
		user.isAuthorized && this.getUserContacts();
	},
	methods: {
		...mapActions('common', ['getUserContacts']),
		submitForm(): void {
			this.$emit('submit-form');
		},
	},
});
